import type { MailboxInfo } from 'owa-client-types';
import isPopout from 'owa-popout-v2/lib/utils/isPopout';
import { getCopilotUpsellEligibility } from './getCopilotUpsellEligibility';

/**
 * Whether the Copilot chat drawer in `targetWindow` renders the upsell pane instead of chat
 * for `mailboxInfo`. Openers use this to avoid starting a BizChat load when the drawer will
 * show upsell.
 */
export function shouldCopilotDrawerShowUpsell(
    targetWindow: Window,
    mailboxInfo: MailboxInfo
): boolean {
    return !isPopout(targetWindow) && getCopilotUpsellEligibility(mailboxInfo);
}
